import styled from "styled-components";
import { responsive } from "../../styles/constants.style";

export const MdmAddActivityWrapper = styled.div`
  .add-activity-container {
    padding: 0px 0 30px 16px;
    ${responsive.MOBILE`
      padding: 16px;
    `}
  }

  .radio-container {
    padding-top: 24px;

    ${responsive.MOBILE`
      padding-top: 0;
    `}
  }

  .topic-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;

    .MuiButton-textPrimary {
      height: 40px;
      margin-right: 16px;
    }
  }

  .cell-topic {
    min-width: 250px;
  }

  .MuiAccordion-root {
    margin-bottom: 16px;
  }

  .accordion-header {
    margin-bottom: 20px;
  }
`;
